(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cravecorn-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-announcement')) {
  class CravecornAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.cc-announce__item')];
      this.i = 0;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const on = this.dataset.rotate === 'true' && this.items.length > 1 && !reduced;
      if (!on) return;

      const ms = parseInt(getComputedStyle(this).getPropertyValue('--cc-announce-dur'), 10) || 5000;

      this.tick = () => {
        this.items[this.i].classList.remove('cc-is-active');
        this.i = (this.i + 1) % this.items.length;
        this.items[this.i].classList.add('cc-is-active');
      };
      this.start = () => { this.stop(); this.timer = setInterval(this.tick, ms); };
      this.stop  = () => clearInterval(this.timer);

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      this.onVis = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVis);

      this.start();
    }

    disconnectedCallback() {
      this.stop && this.stop();
      document.removeEventListener('visibilitychange', this.onVis);
    }

    show(i) {
      this.items.forEach((el, k) => el.classList.toggle('cc-is-active', k === i));
      this.i = i;
    }
  }
  customElements.define('cravecorn-announcement', CravecornAnnouncement);

  // Theme editor: hold on whichever message the merchant is editing.
  document.addEventListener('shopify:block:select', (e) => {
    const bar = e.target.closest('cravecorn-announcement');
    if (!bar || !bar.items) return;
    bar.stop && bar.stop();
    const i = bar.items.indexOf(e.target.closest('.cc-announce__item') || e.target);
    if (i > -1) bar.show(i);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const bar = e.target.closest('cravecorn-announcement');
    if (bar && bar.start) bar.start();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('submit', function(e){
    var form = e.target.closest('.cc-contact__form');
    if (!form) return;
    var reasonEl = form.querySelector('[id^="ContactReason-"]');
    var refEl = form.querySelector('[id^="ContactOrderRef-"]');
    var msgEl = form.querySelector('[id^="ContactMessage-"]');
    if (!msgEl) return;
    var prefix = '';
    if (reasonEl && reasonEl.value) prefix += 'Reason: ' + reasonEl.value + '\n';
    if (refEl && refEl.value) prefix += 'Order reference: ' + refEl.value + '\n';
    if (prefix) msgEl.value = prefix + '\n' + msgEl.value;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-flavours"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-flavours')) {
  class CravecornFlavours extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('.cc-flavours__status');

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.cc-flavour__add[data-variant-id]');
        if (btn) this.add(btn);
      });
    }

    say(msg) { if (this.status) this.status.textContent = msg; }

    add(btn) {
      const id = btn.dataset.variantId;
      const label = btn.dataset.label || 'Add';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      btn.dataset.state = 'loading';
      btn.firstChild.nodeValue = 'Adding…';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');

          btn.dataset.state = 'done';
          btn.firstChild.nodeValue = 'Added';
          this.say('Added to cart.');

          document.dispatchEvent(new CustomEvent('cravecorn:cart:updated'));

          setTimeout(() => {
            btn.dataset.state = '';
            btn.firstChild.nodeValue = label;
          }, 1800);
        })
        .catch((err) => {
          btn.dataset.state = 'error';
          btn.firstChild.nodeValue = 'Try again';
          this.say(err.message);
          setTimeout(() => {
            btn.dataset.state = '';
            btn.firstChild.nodeValue = label;
          }, 2400);
        });
    }
  }
  customElements.define('cravecorn-flavours', CravecornFlavours);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-cart-count')) {
  /* Re-reads /cart.js whenever anything on the page reports a cart change.
     Sections that add to cart should dispatch:
       document.dispatchEvent(new CustomEvent('cravecorn:cart:updated')) */
  class CravecornCartCount extends HTMLElement {
    connectedCallback() {
      this.onUpdate = (e) => {
        const n = e.detail && typeof e.detail.item_count === 'number'
          ? e.detail.item_count
          : null;
        if (n !== null) return this.render(n);
        fetch(window.Shopify.routes.root + 'cart.js')
          .then((r) => r.json())
          .then((c) => this.render(c.item_count))
          .catch(() => {});
      };
      document.addEventListener('cravecorn:cart:updated', this.onUpdate);
    }
    disconnectedCallback() {
      document.removeEventListener('cravecorn:cart:updated', this.onUpdate);
    }
    render(n) {
      this.dataset.count = n;
      this.children[0].textContent = n;
      this.children[1].textContent = n + ' items in cart';
    }
  }
  customElements.define('cravecorn-cart-count', CravecornCartCount);
}

if (!customElements.get('cravecorn-header')) {
  class CravecornHeader extends HTMLElement {
    connectedCallback() {
      this.burger   = this.querySelector('.cc-header__burger');
      this.drawer   = this.querySelector('.cc-header__drawer');
      this.backdrop = this.querySelector('.cc-header__backdrop');
      this.closeBtn = this.querySelector('.cc-header__close');
      if (!this.burger || !this.drawer) return;

      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };

      this.burger.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      // Following a link should not leave the drawer open behind the new page
      this.drawer.addEventListener('click', (e) => { if (e.target.closest('a')) this.close(); });
    }

    open() {
      this.drawer.hidden = false;
      this.backdrop.hidden = false;
      // next frame, so the transition has a starting state to animate from
      requestAnimationFrame(() => {
        this.drawer.classList.add('cc-is-open');
        this.backdrop.classList.add('cc-is-open');
      });
      this.burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      this.closeBtn.focus();
    }

    close() {
      this.drawer.classList.remove('cc-is-open');
      this.backdrop.classList.remove('cc-is-open');
      this.burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      this.burger.focus();
      const hide = () => { this.drawer.hidden = true; this.backdrop.hidden = true; };
      this.drawer.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 400); // fallback if the transition never fires
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.body.style.overflow = '';
    }
  }
  customElements.define('cravecorn-header', CravecornHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-mix"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-mix')) {
  class CravecornMix extends HTMLElement {
    connectedCallback() {
      this.pack     = parseInt(this.dataset.packSize, 10) || 8;
      this.variant  = this.dataset.variantId;
      this.addLabel = this.dataset.addLabel || 'Add to cart';

      this.rows    = [...this.querySelectorAll('.cc-pick')];
      this.slotsEl = this.querySelector('.cc-box__slots');
      this.countEl = this.querySelector('[data-count]');
      this.msgEl   = this.querySelector('[data-msg]');
      this.addBtn  = this.querySelector('[data-add]');

      if (!this.rows.length) return;

      this.flavours = this.rows.map((row) => ({
        name:   row.dataset.name,
        colour: row.dataset.colour,
        thumb:  row.dataset.thumb,
        out:    row.querySelector('.cc-stepper__value'),
        qty:    0
      }));

      this.addEventListener('click', (e) => {
        const step = e.target.closest('.cc-stepper button');
        if (step) return this.step(step);
        if (e.target.closest('[data-clear]'))  return this.clear();
        if (e.target.closest('[data-random]')) return this.random();
        if (e.target.closest('[data-add]'))    return this.submit();
      });

      this.render();
    }

    get total() { return this.flavours.reduce((a, f) => a + f.qty, 0); }

    step(btn) {
      const i = this.rows.indexOf(btn.closest('.cc-pick'));
      const d = parseInt(btn.dataset.step, 10);
      if (d > 0 && this.total >= this.pack) return;
      if (d < 0 && this.flavours[i].qty === 0) return;
      this.flavours[i].qty += d;
      this.render();
    }

    clear()  { this.flavours.forEach((f) => (f.qty = 0)); this.render(); }

    random() {
      this.flavours.forEach((f) => (f.qty = 0));
      for (let i = 0; i < this.pack; i++) {
        this.flavours[Math.floor(Math.random() * this.flavours.length)].qty++;
      }
      this.render();
    }

    render() {
      const total = this.total;
      const left  = this.pack - total;

      this.flavours.forEach((f, i) => {
        f.out.textContent = f.qty;
        const btns = this.rows[i].querySelectorAll('.cc-stepper button');
        btns[0].disabled = f.qty === 0;
        btns[1].disabled = left === 0;
      });

      const bags = [];
      this.flavours.forEach((f) => { for (let i = 0; i < f.qty; i++) bags.push(f); });

      this.slotsEl.innerHTML = Array.from({ length: this.pack }, (_, i) => {
        const f = bags[i];
        if (!f) return '<div class="cc-slot"></div>';
        const inner = f.thumb
          ? '<img src="' + f.thumb + '" alt="" loading="lazy">'
          : '<span class="cc-slot--chip">' + f.name.charAt(0) + '</span>';
        return '<div class="cc-slot cc-slot--filled" style="background:' + f.colour + '">' + inner + '</div>';
      }).join('');

      this.countEl.textContent = total;

      if (!this.addBtn) return;
      this.addBtn.disabled = left !== 0;
      this.addBtn.textContent = left === 0
        ? this.addLabel
        : 'Pick ' + left + ' more bag' + (left === 1 ? '' : 's');

      this.say(left === 0
        ? 'Box is full. ' + this.summary()
        : 'Pick ' + left + ' more bag' + (left === 1 ? '' : 's') + ' to fill the box.');
    }

    summary() {
      return this.flavours.filter((f) => f.qty).map((f) => f.qty + ' × ' + f.name).join(', ');
    }

    say(msg, state) {
      if (!this.msgEl) return;
      this.msgEl.textContent = msg;
      if (state) this.msgEl.dataset.state = state; else delete this.msgEl.dataset.state;
    }

    submit() {
      if (this.total !== this.pack || !this.variant) return;

      const properties = {};
      const parts = [];
      this.flavours.filter((f) => f.qty).forEach((f) => {
        properties[f.name] = f.qty;
        parts.push(f.name.replace(/[^A-Za-z]/g, '').slice(0, 3).toUpperCase() + f.qty);
      });
      properties._mix_code = parts.join('-');

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Adding…';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.variant), quantity: 1, properties: properties }] })
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
          this.addBtn.textContent = 'Added to cart';
          this.say('Added: ' + this.summary());
          document.dispatchEvent(new CustomEvent('cravecorn:cart:updated'));
          setTimeout(() => { this.clear(); }, 1600);
        })
        .catch((err) => {
          this.addBtn.disabled = false;
          this.addBtn.textContent = this.addLabel;
          this.say(err.message, 'error');
        });
    }
  }
  customElements.define('cravecorn-mix', CravecornMix);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-reviews')) {
  class CravecornReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cc-reviews__track');
      this.onVis = () => {
        if (this.track) this.track.style.animationPlayState = document.hidden ? 'paused' : '';
      };
      document.addEventListener('visibilitychange', this.onVis);
    }
    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.onVis);
    }
  }
  customElements.define('cravecorn-reviews', CravecornReviews);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cravecorn-ticker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-ticker')) {
  class CravecornTicker extends HTMLElement {
    connectedCallback() {
      // Pause while the tab is hidden so the animation isn't burning cycles.
      this.track = this.querySelector('.cc-ticker__track');
      this.onVis = () => {
        if (this.track) this.track.style.animationPlayState = document.hidden ? 'paused' : '';
      };
      document.addEventListener('visibilitychange', this.onVis);
    }
    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.onVis);
    }
  }
  customElements.define('cravecorn-ticker', CravecornTicker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cravecorn-hero')) {
  class CravecornHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.cc-hero__slide')];
      this.figs   = [...this.querySelectorAll('.cc-hero__fig')];
      this.tabs   = [...this.querySelectorAll('.cc-hero__tab')];
      this.tabWrap = this.querySelector('.cc-hero__tabs');
      this.index  = 0;

      if (!this.slides.length) return;

      if (this.tabWrap) {
        this.tabWrap.addEventListener('click', (e) => {
          const b = e.target.closest('.cc-hero__tab');
          if (b) this.goTo(+b.dataset.index);
        });
        this.tabWrap.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          this.goTo(this.index + (e.key === 'ArrowRight' ? 1 : -1));
          this.tabs[this.index].focus();
        });
        this.tabWrap.addEventListener('animationend', (e) => {
          if (e.animationName !== 'cc-fill') return;
          const tab = e.target.closest('.cc-hero__tab');
          if (tab && +tab.dataset.index === this.index) this.goTo(this.index + 1);
        });
      }

      let x = null;
      this.addEventListener('touchstart', (e) => { x = e.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x === null) return;
        const d = e.changedTouches[0].clientX - x;
        if (Math.abs(d) > 55) this.goTo(this.index + (d < 0 ? 1 : -1));
        x = null;
      }, { passive: true });

      this.goTo(0);
    }

    goTo(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;

      const slide = this.slides[this.index];
      this.style.background = slide.dataset.bg || '';
      this.dataset.text = slide.dataset.text || 'light';

      this.slides.forEach((el, k) => el.classList.toggle('cc-is-active', k === this.index));
      this.figs.forEach((el, k)   => el.classList.toggle('cc-is-active', k === this.index));
      this.tabs.forEach((el, k) => {
        el.setAttribute('aria-selected', k === this.index);
        el.tabIndex = k === this.index ? 0 : -1;
      });

      const bar = this.tabs[this.index] && this.tabs[this.index].querySelector('i');
      if (bar) {
        bar.style.animation = 'none';
        void bar.offsetWidth;
        bar.style.animation = '';
      }
    }
  }
  customElements.define('cravecorn-hero', CravecornHero);

  document.addEventListener('shopify:block:select', (e) => {
    const hero = e.target.closest('cravecorn-hero');
    if (!hero) return;
    const slide = e.target.closest('.cc-hero__slide') || e.target;
    const i = hero.slides.indexOf(slide);
    if (i > -1) hero.goTo(i);
    hero.classList.add('cc-is-held');
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const hero = e.target.closest('cravecorn-hero');
    if (!hero) return;
    hero.classList.remove('cc-is-held');
    hero.goTo(hero.index);
  });
}

  } catch(e) { console.error(e); }
})();
})();
